import {
    
    GET_ROLE,
    GET_ROLE_ERROR,
    GET_ALL_ROLES,
    GET_ALL_ROLES_ERROR,
    ADD_ROLE,
    ADD_ROLE_ERROR,
} from "../actions/types";

const initialState = {
    allRoles: null,
    selectedRole: null,
    newRole: null,
    isLoadinRoles: true,
    success: false,
};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {
        case GET_ROLE:
        return {
            ...state,
            selectedRole: payload,
            isLoadinRoles: false,
            success: true,
        };
        case GET_ALL_ROLES:
        return {
            ...state,
            allRoles: payload,
            isLoadinRoles: false,
            success: true,
        };
        case ADD_ROLE:
        return {
            ...state,
            newRole: payload,
        };
        case GET_ROLE_ERROR:
        return {
            ...state,
            selectedRole: payload,
            isLoadinRoles: false,
            success: false,
        };
        case GET_ALL_ROLES_ERROR:
        return {
            ...state,
            allRoles: payload,
            isLoadinRoles: false,
            success: false,
        };
        case ADD_ROLE_ERROR:
        return {
            ...state,
            newRole: payload,
            isLoadinRoles: false,
            success: false,
        };
        default:
        return state;
    }
}
